import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import FetchingSelect from '@/components/FetchingSelect';
import { MarathonAchievementType, UpsertMarathonAchievementType } from '@/models/achievement.model';
import { getRunEventsLookup } from '@/services/run-event.service';
import { getRunEventDistancesLookup } from '@/services/run-event-distance.service';
import { RunEventType } from '@/models/run-event.model';

const modelSchema = Schema.Model<UpsertMarathonAchievementType>({
  marathonDistanceId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertMarathonAchievementType = {
  marathonDistanceId: undefined,
};

export interface MarathonAchievementInitValue {
  marathonId?: number,
  marathonDistanceId?: number,
};


interface MarathonFormProps{
  formObject?: MarathonAchievementType;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
  initValue?: MarathonAchievementInitValue;
}

const MarathonForm: React.FC<MarathonFormProps> = ({ formObject, onFormChange, formRef, loading, initValue }) => {
  const [formValue, setFormValue] = useState<UpsertMarathonAchievementType>(emptyModel);
  const [marathonId, setMarathonId] = useState<number|undefined>(undefined);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
      setMarathonId(formObject.marathonId);
    } else {
      setFormValue({...emptyModel, marathonDistanceId: initValue?.marathonDistanceId});
      setMarathonId(initValue?.marathonId);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-first-country' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="marathonId">
              <Form.Label>Marathon</Form.Label>
              <FetchingSelect block
                fetchData={(text, page) => getRunEventsLookup(text, page, RunEventType.Marathon)} 
                placeholder="Select a marathon"
                value={marathonId}
                onChange={val => {setMarathonId(val); setFormValue(pre => ({...pre, marathonDistanceId: undefined}));}}
              />   
            </Form.Group>
          </Col>
          <Col span={{xs:24, lg:6}}>
            <Form.Group controlId="marathonDistanceId">
              <Form.Label>Marathon Distance</Form.Label>
              <Form.Control name="marathonDistanceId" accepter={FetchingSelect} block
                fetchData={(text, page) => getRunEventDistancesLookup(text, marathonId, page)} 
                placeholder="Select a distance"
                value={formValue.marathonDistanceId}
                onChange={val=> setFormValue(pre => ({...pre, marathonDistanceId: val}))}
                reFetchOnOpen={true}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            ...
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default MarathonForm;